export default __webpack_public_path__ + "static/people_04-4b790436a7a1da91c01ba6a85826dbae.png";